<template>
  <section v-if="card.notes" class="card-profile-collection-notes">
    <h4 class="secondary-font">
      Notes
    </h4>

    <p>{{ card.notes }}</p>
  </section>
</template>

<script>
export default {
  props: {
    card: Object,
  },
};
</script>

<style lang="scss" scoped>
.card-profile-collection-notes {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}
</style>
